import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { asyncMiddleware } from "@coverme/redux";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunk, asyncMiddleware];

export const createReduxStore = (reducers, initialState = {}) => {
    var store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(...middleware)));
    if (window.Cypress) {
        window.store = store;
    }

    return store;
};
